// Cercatore dello storico stagioni dei giocatori.
// Stessa normalizzazione dei nomi usata nello Studio (studioReconcile.js): trim + minuscolo.
import { decodeHtmlEntities } from '../utils/decodeHtmlEntities.js';

function normName(name) {
  return decodeHtmlEntities(String(name || '')).trim().toLowerCase();
}

/**
 * Cerca le stagioni di un giocatore in un index già caricato.
 * @param {Object|null} index - mappa nomeNormalizzato -> array stagioni
 * @param {string} name - nome giocatore (qualsiasi casing/spazi)
 * @returns {Array} stagioni (già ordinate dalla più recente) o []
 */
export function lookupHistory(index, name) {
  if (!index) return [];
  return index[normName(name)] || [];
}

let _cache = null;

/**
 * Carica (in lazy, una volta) il dataset storico e restituisce le stagioni del giocatore.
 * @param {string} name
 * @returns {Promise<Array>}
 */
export async function getPlayerHistory(name) {
  if (!_cache) {
    const mod = await import('../data/historical-stats.json');
    _cache = mod.default || mod;
  }
  return lookupHistory(_cache, name);
}
